// Tracks whether the season-goals board has been shown in this browser session.
//
// sessionStorage (not localStorage) is deliberate: the board should appear once
// per sign-in, not once ever. Navigating the portal or refreshing keeps the flag;
// logging out clears it, so the next sign-in shows the board again.

const SEEN_KEY = 'mst_goals_splash_seen';

export function hasSeenGoalsSplash() {
  try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch { return true; }
}

export function markGoalsSplashSeen() {
  try { sessionStorage.setItem(SEEN_KEY, '1'); } catch { /* private mode — show again next load */ }
}

export function clearGoalsSplashSeen() {
  try { sessionStorage.removeItem(SEEN_KEY); } catch { /* nothing to clear */ }
}
